import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import "./index.css";
import App from "./App";
import { LangProvider } from "./lib/i18n";
import { AuthProvider } from "./lib/auth";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 30_000, refetchOnWindowFocus: false, retry: 1 },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <HelmetProvider>
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <LangProvider>
          <AuthProvider>
            <App />
            <Toaster
              position="bottom-right"
              theme="dark"
              toastOptions={{
                style: {
                  background: "#101018",
                  border: "1px solid rgba(168,85,247,0.35)",
                  color: "#f8f8f8",
                },
              }}
            />
          </AuthProvider>
        </LangProvider>
      </QueryClientProvider>
    </BrowserRouter>
  </HelmetProvider>,
);
